import { Channel, ChannelGroupingResult, ChannelType, MaybeChannelGroupingResult } from "./channelgrouping";
import {ParsedUrlParams} from "./urlparams";
import { Utms } from "./utms";

export default class EmailChannel {

    public static is(parsed: ParsedUrlParams) : MaybeChannelGroupingResult
    {       
        const utms = new Utms(parsed);

        const adContactHistoryId = utms.getFirst('ad_chid');
        if (adContactHistoryId) {
            return new ChannelGroupingResult(Channel.Email, ChannelType.Other);
        }

        const medium = utms.getMedium();
        if (medium) {
            const isEmail = medium.toLowerCase() === 'email';
            if (isEmail) {
                return new ChannelGroupingResult(Channel.Email, ChannelType.Other);
            }
        }
        return null;
    }

}